import React, { type ComponentType } from 'react'
import { Route, type RouteProps } from 'react-router'
import { type DashRouteNameProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { type DashRouteName } from 'utils/routing/routes'
import { type AccessControlConfig } from 'legacy/components/AccessControl/accessControl.utils'
import { useCoreContext } from 'utils/core/RPPCoreContext'

// Note that the route prop is used by the DashSwitch to determine the Route's path
export interface DashRouteProps<TRoute extends DashRouteName>
  extends Pick<RouteProps, 'children' | 'exact' | 'render'> {
  component?: ComponentType<DashRouteNameProps<TRoute>>
  route?: TRoute
  accessControl?: AccessControlConfig
}

// Default to the "base" route, which provides no params to the component prop
// (Meaning, no `:partnerId` or `:retailerId`)
export function DashRoute<TRoute extends DashRouteName = 'base'>({
  route,
  accessControl,
  ...rest
}: DashRouteProps<TRoute>) {
  const hasAccess = useAccessControl()
  const { routesByName } = useCoreContext()

  if (accessControl && !hasAccess(accessControl)) return null
  // `path` can be injected by the DashSwitch
  const routeProps = { ...(rest as RouteProps) }

  // If it hasn't been injected, we add it ourselves
  if (!routeProps.path && route) {
    routeProps.path = routesByName[route]
  }

  return <Route {...routeProps} />
}
